function pre(a = null){
	console.log(a);
}

export { pre };
